
// 只放公共的接口
import { put, post } from '@/request/http'
import { home_post } from '@/request/home_http'

// 埋点-单个
export const statSign = p => put('/api/statSign', p); 

// 埋点-批量
export const uploadLog = p => post('/api/uploadLog', p);

// 获取用户信息
export const getMemberInfo = () => post('/api/member/getMemberInfo.action', {})

// 获取ip
export const getRequestIp = () => post('/api/H5/requestInfo', {}); 

// 性能数据上报接口
export const performanceLog = p => post('/api/performance/log', p);

// ott-apk 打点接口（和官网打点接口一样）
export const ottApkLog = logData => home_post('/webLogApi/log/upload', {
	platform: 1, // 打点平台类型：0 官网, 1:ott打点
	logData // JSONArray
});
